"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArenaLink = void 0;
var ArenaLink = function (slug) {
    return "https://app.loop.fans/collection/".concat(slug);
};
exports.ArenaLink = ArenaLink;
